import type { FC } from 'react';
import clsx from 'clsx';

export interface ToastContentProps {
  kind: 'success' | 'error';
}

const descriptionClasses = clsx('text-info-500 mt-2 text-sm leading-5 font-normal');
const titleClasses = clsx('text-info-900 mt-[3px] leading-5 font-medium');
const containerClasses = clsx('flex flex-col gap-1 max-w-[280px]');

export const ToastContent: FC<ToastContentProps> = ({ kind }) => {
  if (kind === 'error') {
    return (
      <div className={containerClasses}>
        <p className={titleClasses}>Duplicating Endorsement Failed</p>
        <p className={descriptionClasses}>
          We encountered an issue while duplicating the endorsement to multiple contracts.
          <br />
          <br />
          Please return to the endorsement and try again.
        </p>
      </div>
    );
  }

  return (
    <div className={containerClasses}>
      <p className={titleClasses}>Duplicating Endorsement</p>
      <p className={descriptionClasses}>
        The endorsement is being duplicated across your selected contracts. This may take a moment.
        <br />
        <br />
        You can view the progress with direct links in the activity log.
      </p>
    </div>
  );
};
